import gql from "graphql-tag";


export const GET_INTERNAL_STATUS = gql`
 query {
  stages: internalstatus {
    id
    name
    }
  }
 `
export const GET_EXTERNAL_STATUS = gql`
 query {
  externalstatus {
    id
    name
    }
  }
 `